export default __webpack_public_path__ + "static/media/article2.a2a0b885.png";